import {
  PROBATION_QUESTION_FETCHING,
  PROBATION_QUESTION_FAILED,
  PROBATION_QUESTION_SUCCESS,
  RESULT_PROBATION_SUCCESS,
  RESULT_PROBATION_FETCHING,
  RESULT_PROBATION_FAILED,
  PROBATION_EMPLOYEES_FETCHING,
  PROBATION_EMPLOYEES_SUCCESS,
  PROBATION_EMPLOYEES_FAILED,
} from "./types";
import ProbationService from "../services/probation.service";

export const getAllProbationQuestionSet = (query) => async (dispatch) => {
  try {
    dispatch({
      type: PROBATION_QUESTION_FETCHING,
    });
    const res = await ProbationService.getAllProbationQuestionSet(query);
    if (res) {
      dispatch({
        type: PROBATION_QUESTION_SUCCESS,
        payload: res.data,
      });
    }
  } catch (error) {
    dispatch({ type: PROBATION_QUESTION_FAILED });
    return error;
  }
};

export const addProbationQuestionSet = (formdata) => async (dispatch) => {
  try {
    const res = await ProbationService.addProbationQuestionSet(formdata);
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateProbationQuestionSet = (formdata) => async (dispatch) => {
  try {
    const res = await ProbationService.updateProbationQuestionSet(formdata);
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateProbationQuestionSetStatus = (formdata) => async (dispatch) => {
  try {
    const res = await ProbationService.updateProbationQuestionSetStatus(formdata);
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
};

// export const addProbationQuestion = (formdata) => async (dispatch) => {
//   try {
//     const res = await ProbationService.addProbationQuestion(formdata);
//     if (res) {
//       return res;
//     }
//   } catch (error) {
//     dispatch({
//       type: PROBATION_QUESTION_FAILED,
//     });
//   }
// };

export const updateProbationQuestionStatus = (formdata) => async (dispatch) => {
  try {
    const res = await ProbationService.updateProbationQuestionStatus(formdata);
    if (res) {
      return res;
    }
  } catch (error) {
    dispatch({
      type: PROBATION_QUESTION_FAILED,
    });
  }
};

export const updateProbationManager = (formData) => async () => {
  try {
    const res = await ProbationService.updateProbationManager(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    return "Error";
  }
};

export const updateProbationAdmin = (formData) => async () => {
  try {
    const res = await ProbationService.updateProbationAdmin(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    return "Error";
  }
};

export const getProbationAndAnswer = async (formData) => {
  try {
    const res = await ProbationService.getProbationAndAnswer(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    return "Error";
  }
};

export const getProbationEmployee = () => async (dispatch) => {
  try {
    dispatch({
      type: PROBATION_QUESTION_FETCHING,
    });
    const res = await ProbationService.getProbationEmployee();
    if (res) {
      dispatch({
        type: PROBATION_QUESTION_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: PROBATION_QUESTION_FAILED,
    });
  }
};

// manager
export const getProbationEmployees = () => async (dispatch) => {
  try {
    dispatch({
      type: PROBATION_QUESTION_FETCHING,
    });
    const res = await ProbationService.getProbationEmployees();
    if (res) {
      dispatch({
        type: PROBATION_EMPLOYEES_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: PROBATION_EMPLOYEES_FAILED,
    });
  }
};

export const updateProbationEmployee = (formData) => async (dispatch) => {
  try {
    const res = await ProbationService.updateProbationEmployee(formData);
    if (res) {
      return res;
    }
  } catch (err) {
    dispatch({
      type: PROBATION_QUESTION_FAILED,
    });
  }
};

// export const getProbationEmployees = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: PROBATION_QUESTION_FETCHING,
//     });
//     const res = await ProbationService.getProbationEmployees();
//     if (res) {
//       dispatch({
//         type: PROBATION_EMPLOYEES_SUCCESS,
//         payload: res.data,
//       });
//     }
//   } catch (err) {
//     dispatch({
//       type: PROBATION_EMPLOYEES_FAILED,
//     });
//     console.log(err);
//   }
// };

export const getProbation = (idProbation) => async (dispatch) => {
  try {
    dispatch({
      type: RESULT_PROBATION_FETCHING,
    });
    const res = await ProbationService.getProbation(idProbation);
    if (res) {
      dispatch({
        type: RESULT_PROBATION_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: RESULT_PROBATION_FAILED,
    });
  }
};

export const getProbationEmployeeAnswer = (idEmployee) => async (dispatch) => {
  try {
    dispatch({
      type: PROBATION_QUESTION_FETCHING,
    });
    const res = await ProbationService.getProbationEmployeeAnswer(idEmployee);
    if (res) {
      dispatch({
        type: PROBATION_QUESTION_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: PROBATION_QUESTION_FAILED,
    });
  }
};

export const getProbationAdmin = (query) => async (dispatch) => {
  try {
    dispatch({ type: PROBATION_EMPLOYEES_FETCHING });
    const res = await ProbationService.getProbationAdmin(query);
    if (res) {
      dispatch({
        type: PROBATION_EMPLOYEES_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: PROBATION_EMPLOYEES_FAILED,
    });
    console.log(err);
  }
};
